import { type TextColorType } from "@/gc-sanity-types"
import { clsx } from "@/src/utils/clsx"

type SubHeadingElementProps = {
    text: string
    className?: string
    textColor?: TextColorType
}

export default function SubHeadingElement({
    text,
    className,
    textColor
}: SubHeadingElementProps) {
    if (!text) return null
    return (
        <p className={clsx(textColor, "Trade_Gothic_Text_16_150_0_300", className)}>
            {text}
        </p>
    )
}
